import { render, staticRenderFns } from "./NotificationMessageCenter.vue?vue&type=template&id=85d3c15c&"
import script from "./NotificationMessageCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationMessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMessageCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports